import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

const TESTIMONIALS = [
  { quote: "IROCRUZ genuinely improved my haemoglobin within six weeks. Delivery was prompt and the pharmacist even called to confirm the order details.", name: "Meena Kulkarni", city: "Pune", product: "IROCRUZ Tablets" },
  { quote: "Ordered PANTOPRIME-DSR in bulk with just our DL and GST after payment — smooth process, genuine medicines and proper billing. Much better than our old distributor.", name: "Rahul Sharma", city: "Mumbai", product: "PANTOPRIME-DSR" },
  { quote: "We stock GUTWIBE and CALCIBOOM for our pharmacy. The B2B flow with DL + GST after payment is quick, compliant and saves us a distributor call.", name: "Carewell Pharmacy", city: "Nashik", product: "B2B Wholesale Order" },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-8 py-16" data-testid="testimonials-section">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center">
        Trusted by <span className="text-emerald-800">Customers & Pharmacies</span>
      </h2>
      <div className="max-w-2xl mx-auto mt-10">
        {/* Cards stack in one grid cell: crossfade with no blank frame and no height collapse */}
        <div className="grid">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={false}
              animate={{ opacity: i === index ? 1 : 0, y: i === index ? 0 : 12 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              style={{ pointerEvents: i === index ? "auto" : "none" }}
              className="col-start-1 row-start-1 bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex justify-center gap-1">
                {[0, 1, 2, 3, 4].map((s) => <Star key={s} size={16} className="fill-amber-400 text-amber-400" />)}
              </div>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed mt-4">“{t.quote}”</p>
              <p className="font-bold text-slate-900 text-sm mt-5 flex items-center justify-center gap-1.5">
                {t.name}, {t.city}
                <BadgeCheck size={14} className="text-emerald-700" />
              </p>
              <span className="inline-block mt-2 text-[11px] font-semibold text-emerald-800 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-md">{t.product}</span>
            </motion.div>
          ))}
        </div>
        <div className="flex justify-center gap-2 mt-5">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIndex(i)}
              className={`h-2 rounded-full transition-all duration-300 ${i === index ? "w-6 bg-emerald-700" : "w-2 bg-slate-300 hover:bg-slate-400"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
